// extracted by mini-css-extract-plugin
module.exports = {"codeWrapper":"PaymentQrCodeField_codeWrapper__Yra_M","code":"PaymentQrCodeField_code__kSV_G"};